<template>
	<div class="center_right">
		<div class="center_commNav">
			<div class="center_commNavItem" @click="activeName=item.id" :class="{'active':activeName==item.id}" v-for="(item,index) in commNavs">{{item.name}}</div>
		</div>
		<div v-show="activeName=='1'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="实验名称：">
							<el-input v-model="finiOnname" placeholder="请输入作业名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="课程类型：">
							<el-select :popper-append-to-body='false' v-model="finiOntypeId" placeholder="请选择课程类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOnCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOnFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOnlistData" border stripe>
					<emptymain slot='empty' :emptylist='finiOnlistData'></emptymain>
					<el-table-column label="实验封面" align='center'>
						<template slot-scope="scope">
							<div class="center_labinfo pointer" @click="getLabInfo(scope.row)">
								<img :src="baseurl + scope.row.cover" />
							</div>
						</template>
					</el-table-column>
					<el-table-column label="实验名称" prop="vrName" align='center' :show-overflow-tooltip='true'>
						<template slot-scope="scope">
							<span class="pointer" @click="getLabInfo(scope.row)">
								{{scope.row.vrName}}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="实验类型" prop="typeName" align='center'>
					</el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' type='warning' @click='collectionSimuDelete(scope.row)'>取消收藏</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOnCurrentChange" :current-page="finiOncurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOntotal">
				</el-pagination>
			</div>
		</div>
		<div v-show="activeName=='2'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="课程名称：">
							<el-input v-model="finiOffname" placeholder="请输入课程名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="课程类型：">
							<el-select :popper-append-to-body='false' v-model="finiOfftypeId" placeholder="请选择课程类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="授课老师：">
							<el-input v-model="finiOffuserName" placeholder="请输入发布人" clearable></el-input>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOffCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOffFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOfflistData" ref='centerfiniOffTable' border stripe>
					<emptymain slot='empty' :emptylist='finiOfflistData'></emptymain>
					<el-table-column label="课程信息" width='450' align='center'>
						<template slot-scope="scope">
							<div class="center_courseBox pointer" @click="toCourseindex(scope.row)">
								<div class="center_courseinfo">
									<img :src="baseurl + scope.row.banner" />
								</div>
								<div class="center_courseTitle text-ellipsis">{{scope.row.name}}</div>
								<div class="center_courseDesc text-ellipsis"><i class="el-icon-s-order"></i>{{scope.row.courseTypeName}}</div>
								<div class="center_courseDesc text-ellipsis"><i class="el-icon-s-custom"></i>{{scope.row.teacherName}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="课程简介" prop="info" align='center' :show-overflow-tooltip='true'>
					</el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' type='warning' @click='collectionDelete(scope.row)'>取消收藏</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOffCurrentChange" :current-page="finiOffcurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOfftotal">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { listMajorByPid } from '@/api/major'
	import { collectionList, collectionDelete } from '@/api/collection.js'
	import { myVrCollection, userCollectionRemove } from '@/api/simulation.js'
	export default {
		data() {
			return {
				activeName: '1',
				commNavs: [{
					name: '虚拟仿真',
					id: '1'
				}, {
					name: '在线课程',
					id: '2'
				}],
				limit: 10,
				typeList: [],
				//虚拟仿真
				finiOnname: '',
				finiOntypeId: '',
				finiOnlistData: [],
				finiOncurrent: 1,
				finiOntotal: 0,
				//在线课程
				finiOffuserName: '',
				finiOffname: '',
				finiOfftypeId: '',
				finiOfflistData: [],
				finiOffcurrent: 1,
				finiOfftotal: 0,
			}
		},
		created() {
			this.getTypeList();
			this.getfiniOnListData();
			this.getfiniOffListData();
		},
		methods: {
			clearfiniOnFilter() {
				this.finiOnname = '';
				this.finiOntypeId = '';
				this.finiOncurrent = 1
				this.getfiniOnListData();
			},
			finiOnCurrentChange(finiOncurrent) {
				this.finiOncurrent = finiOncurrent;
				this.getfiniOnListData();
			},
			getfiniOnListData() {
				var data = {
					vrName: this.finiOnname ? this.finiOnname : null,
					typeId: this.finiOntypeId ? this.finiOntypeId : null,
					current: this.finiOncurrent,
					limit: this.limit,
				}
				myVrCollection(data).then(res => {
					if(res.code == "OK") {
						this.finiOnlistData = res.data.records;
						this.finiOntotal = res.data.total;
					}
				})
			},
			clearfiniOffFilter() {
				this.finiOffname = '';
				this.finiOfftypeId = '';
				this.finiOffuserName = '';
				this.finiOffcurrent = 1
				this.getfiniOffListData();
			},
			finiOffCurrentChange(finiOffcurrent) {
				this.finiOffcurrent = finiOffcurrent;
				this.getfiniOffListData();
			},
			getfiniOffListData() {
				var data = {
					teacherName: this.finiOffuserName ? this.finiOffuserName : null,
					courseName: this.finiOffname ? this.finiOffname : null,
					typeId: this.finiOfftypeId ? this.finiOfftypeId : null,
					current: this.finiOffcurrent,
					limit: this.limit,
				}
				collectionList(data).then(res => {
					if(res.code == "OK") {
						this.finiOfflistData = res.data.records;
						this.finiOfftotal = res.data.total;
					}
				})
			},
			getTypeList() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(res => {
					this.typeList = res.data;
				})
			},
			//取消收藏课程
			collectionSimuDelete(item) {
				this.$confirm('确定取消收藏?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					userCollectionRemove({
						vrDetailId: item.vrDetailId,
						resourceId: item.resourceId,
					}).then(res => {
						if(res.code == "OK") {
							this.$message({
								type: 'success',
								message: '取消成功!'
							});
							this.getfiniOnListData()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					});
				});
			},
			//取消收藏课程
			collectionDelete(item) {
				this.$confirm('确定取消收藏?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					collectionDelete({
						id: item.id
					}).then(res => {
						if(res.code == "OK") {
							this.$message({
								type: 'success',
								message: '取消成功!'
							});
							this.getfiniOffListData()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					});
				});
			},
			getLabInfo(item) {
				this.$router.push({
					name: 'fictitiousinfo',
					query: {
						vrDetailId: item.vrDetailId,
						resourceId: item.resourceId,
					}
				})
			},
			toCourseindex(item) {
				this.$router.push({
					name: 'coursedetail',
					query: {
						courseId: item.courseId
					}
				})
			},

		}
	}
</script>